import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { MdDelete } from 'react-icons/lib/md';
import Modal from 'react-modal';
import _ from 'lodash'

import { fetch_lkp_Studio_AE, fetchMembersForStudio, fetchMembersNoStudio } from '../../actions/additional_actions';
import { withAuth } from '../../actions/';
import { modalStyle } from '../../constants';

class ManageStudioSubTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            studioId: '',
            toEdit: null,
            queryMembers: '',
        };

        this.handleStudioChange = this.handleStudioChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteMember = this.deleteMember.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addHandler = this.addHandler.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { studios_AE } = this.props;

        if (studios_AE.length === 0) this.props.fetch_lkp_Studio_AE();
    }

    getOptionsForStudio() {
        return this.props.studios_AE.map(value => {
            return {
                label: value.studio,
                value: value.id
            }
        });
    }

    handleStudioChange(option) {
        const studioId = option ? option.value : '';
        this.setState({ studioId });

        if (studioId !== null) {
            this.props.fetchMembersForStudio(studioId);
        }
    }

    handleSearch() {
        return (e) => {
            this.setState({ queryMembers: e.target.value });

            clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.props.fetchMembersNoStudio();
            }, 200);
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        let method = 'post';
        let url = 'projects/AddMemberToStudio_AE';

        let member_AE_Id = this.state.toEdit.id;
        let studioId = this.state.studioId;

        const data = { member_AE_Id, studioId }

        withAuth(
            { method, url, data },
            () => {
                this.props.fetchMembersForStudio(this.state.studioId);
                this.closeModal();
            },
            this.errorHandler
        )
    }

    deleteMember(memberId) {
        const url = `/projects/DeleteStudioMember_AE/${memberId}`;
        // TODO: This is a working code for a member that belongs so multiple studios. For the next release
        // const url = `/projects/DeleteStudioMember_AE/${memberId}/${this.state.studioId}`;
        withAuth(
            { method: 'delete', url },
            () => {
                this.props.fetchMembersForStudio(this.state.studioId);
            },
            this.errorHandler
        );
    }

    closeModal() {
        this.setState({ toEdit: null });
    }

    addHandler(mem) {
        return () => {
            this.setState({ queryMembers: '', toEdit: mem });
        }
    }

    renderEditForm(toEdit, studioId) {
        let currentStudio = _.find(this.props.studios_AE, function (o) { return o.id === studioId; });

        return (
            <div className="member-form modal-form">
                <h1>Add member to {currentStudio.studio}</h1>

                <form onSubmit={this.handleSubmit}>
                    <div>
                        <div className="member-details two-cols">
                            <div className="control">
                                <label>First Name</label>
                                <span>{toEdit.employee.firstName}</span>
                            </div>
                            <div className="control">
                                <label>Last Name</label>
                                <span>{toEdit.employee.lastName}</span>
                            </div>
                        </div>

                        <div className="member-details two-cols">
                            <div className="control">
                                <label>Discipline</label>
                                <span>{toEdit.lkp_Members_Discipline_AE && toEdit.lkp_Members_Discipline_AE.memberDiscipline}</span>
                            </div>
                            <div className="control">
                                <label>Studio</label>
                                <span>{currentStudio.studio}</span>
                            </div>
                        </div>
                    </div>

                    <button className="btn-update">
                        Add
                 </button>
                </form>

                <div className="modal-close"
                    onClick={() => this.closeModal()}>
                    <span className="close"></span>
                </div>
            </div>
        )
    }

    renderModal() {
        const { toEdit, studioId } = this.state;

        let Content = null;
        if (toEdit) Content = this.renderEditForm(toEdit, studioId);

        return (
            <Modal
                isOpen={!!Content}
                style={modalStyle}
                contentLabel="Add studio member">

                {Content}

            </Modal>
        );
    }

    renderResults() {
        return (
            <div className="results">
                <ul>
                    {this.props.membersNOstudio_AE.map(mem =>
                        <li key={mem.id}>
                            <strong>{mem.employee.firstName + ' ' + mem.employee.lastName}</strong>
                            <span>{mem.lkp_Members_Discipline_AE && mem.lkp_Members_Discipline_AE.memberDiscipline}</span>
                            {<button className="add" onClick={this.addHandler(mem, false)}>+</button>}
                        </li>
                    )}
                </ul>
            </div>
        );
    }

    renderStudioMembersTable() {
        return (
            <div className="col s12 padding-bottom-175">
                <div className="table-scroll height-500">
                    <table className="td-table-border th-table-border table-striped">
                        <thead>
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Studio</th>
                                <th>Discipline</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.studioMembers_AE.map(member =>
                                <tr key={member.id}>
                                    <td>{member.employee.firstName}</td>
                                    <td>{member.employee.lastName}</td>
                                    <td>{member.studio_Members_AE.length > 0 && member.studio_Members_AE[0].lkp_Studio_AE.studio}</td>

                                    {/* TODO: This is a working code for a member that belongs so multiple studios. For the next release 
                                    <td>
                                        {member.studio_Members_AE.length === 0
                                            ? null
                                            : member.studio_Members_AE.length === 1
                                                ? <span>{member.studio_Members_AE[0].lkp_Studio_AE.studio}</span>
                                                : member.studio_Members_AE.length > 1
                                                    ? member.studio_Members_AE.map((st, i) => <span key={i}>
                                                        {!!i && ", "}
                                                        <span>{st.lkp_Studio_AE.studio}</span>
                                                    </span>)
                                                    : null}
                                    </td> */}

                                    <td>{member.lkp_Members_Discipline_AE && member.lkp_Members_Discipline_AE.memberDiscipline}</td>
                                    {this.renderRowButtons(member)}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderRowButtons(member) {
        return (
            <td>
                <button onClick={() => this.deleteMember(member.id)}>
                    <span><MdDelete size={20} color='#8492a6' /></span>
                </button>
            </td>
        )
    }

    render() {
        const { studioId, queryMembers } = this.state;

        return (
            <div id="contrParentSubTab">

                <div className="row-wide" id="contrSubTab">
                    <div className="col l3 m6 s12 padding-bottom-2">
                        <div className="controls with-select z-index-20" id="selectRounded">
                            <label className="label-select-search padding-top-2">Please select a studio</label>
                            <Select name=''
                                value={studioId}
                                options={this.getOptionsForStudio()}
                                onChange={this.handleStudioChange}
                            />
                        </div>
                    </div>
                </div>

                <div id="AeBidTracker" className="row-wide">

                    <div className="col s12">
                        <h4 className="bar-bottom">Studio Members</h4>
                    </div>

                    {studioId !== null && studioId !== '' &&
                        <div className="section-search top-075">
                            <div className="box-wrap">
                                <input type="text" name="search"
                                    value={queryMembers}
                                    onChange={this.handleSearch()}
                                    placeholder="Search for studio members to add ..." />
                            </div>

                            {queryMembers ? this.renderResults() : null}

                        </div>}

                    {this.renderModal()}

                    {this.props.studioMembers_AE.length > 0
                        ? this.renderStudioMembersTable()
                        : null}

                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        studios_AE: state.additionalProjectsStore.studios_AE,
        studioMembers_AE: state.additionalProjectsStore.studioMembers_AE,
        membersNOstudio_AE: state.additionalProjectsStore.membersNOstudio_AE,
    };
}

export default connect(mapStateToProps, { fetch_lkp_Studio_AE, fetchMembersForStudio, fetchMembersNoStudio, })(ManageStudioSubTab);
